import React from 'react';
import VoiceDashboard from '../components/voice/VoiceDashboard';
import VoiceAgents from '../components/voice/VoiceAgents';
import { Bot } from 'lucide-react';
import { useUiLanguage } from '../context/UiLanguageContext';

const VoicePage = () => {
    const { t } = useUiLanguage();
    return (
        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 space-y-6" style={{ color: 'var(--ink)' }}>
            <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 border-b pb-5" style={{ borderColor: 'var(--line)' }}>
                <div>
                    <div className="flex items-center gap-2 text-[11px] uppercase tracking-wider font-bold" style={{ color: 'var(--gold)' }}>
                        <Bot className="w-3.5 h-3.5" />
                        {t('voice.kicker', 'Autonomous Voice Operations')}
                    </div>
                    <h1
                        className="text-2xl sm:text-3xl font-bold tracking-tight mt-1"
                        style={{ color: 'var(--ink)', fontFamily: 'var(--font-display)' }}
                    >
                        {t('voice.title', 'AI Voice Operations')}
                    </h1>
                    <p className="text-xs sm:text-sm mt-1" style={{ color: 'var(--ink-muted)' }}>
                        {t('voice.subtitle', 'Autonomous legal intake, call handling, live monitoring & sentiment analytics')}
                    </p>
                </div>
            </div>

            <div className="w-full space-y-6">
                {/* Main Analytics Dashboard */}
                <VoiceDashboard />

                {/* Admin Brain Center (Visible only for admin role) */}
                <VoiceAgents />
            </div>
        </div>
    );
};

export default VoicePage;

